import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TabsWrapper = styled.div`
	display: flex;
`;

export const ControlsWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;
`;

export const ActionItem = styled.div`
	padding: 0 8px;

	&:last-child {
		padding-right: 0;
	}
`;

export const SearchWrapper = styled(ActionItem)`
	display: flex;
	align-items: center;

	> div:first-child {
		width: 360px;
	}
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 8px;
`;

export const TooltipIcon = styled.div`
	padding-left: 4px;
	margin-bottom: 2px;
	display: flex;
`;

export const TooltipContent = styled.div`
	text-align: left;
	padding: 4px;
`;
